/**
 * This file re-exports the tRPC client from the new location for backwards compatibility.
 * All new code should import from "~/trpc/client" instead.
 */
import { createTRPCClient, httpBatchLink, loggerLink } from "@trpc/client";
import type { inferRouterInputs, inferRouterOutputs } from "@trpc/server";
import superjson from "superjson";
import type { AppRouter } from "~/server/api/root";

// Re-export the React Query hooks from the new trpc client
export { api } from "~/trpc/client";

const getBaseUrl = () => {
	if (typeof window !== "undefined") {
		return ""; // browser should use relative url
	}
	if (process.env.VERCEL_URL) {
		return `https://${process.env.VERCEL_URL}`; // SSR should use vercel url
	}
	return `http://localhost:${process.env.PORT ?? 3000}`; // dev SSR should use localhost
};

/** Vanilla tRPC client for use outside React components (stores, utilities, etc.) */
export const proxyApi = createTRPCClient<AppRouter>({
	links: [
		loggerLink({
			enabled: (opts) =>
				process.env.NODE_ENV === "development" ||
				(opts.direction === "down" && opts.result instanceof Error),
		}),
		httpBatchLink({
			url: `${getBaseUrl()}/api/trpc`,
			transformer: superjson,
		}),
	],
});

/**
 * Inference helper for inputs.
 *
 * @example type HelloInput = RouterInputs['example']['hello']
 */
export type RouterInputs = inferRouterInputs<AppRouter>;

/**
 * Inference helper for outputs.
 *
 * @example type HelloOutput = RouterOutputs['example']['hello']
 */
export type RouterOutputs = inferRouterOutputs<AppRouter>;
